exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-shared-DropSection-container{text-align:center;height:100%;width:100%;cursor:pointer;min-height:200px}.src-components-shared-DropSection-label{vertical-align:middle;color:#929292}.src-components-shared-DropSection-uploadIcon{font-size:25px !important}.src-components-shared-DropSection-dropzone{width:100%;height:100%;border:3px solid #b3b3b3 !important;border-radius:0 !important;background-color:#fcfcfc !important}.src-components-shared-DropSection-dropzone_drag{background-color:#e6e6e6 !important}.src-components-shared-DropSection-uploadLink{color:#15284b}.src-components-shared-DropSection-uploadLink:hover{text-decoration:underline}", ""]);

// exports
exports.locals = {
	"container": "src-components-shared-DropSection-container",
	"label": "src-components-shared-DropSection-label",
	"uploadIcon": "src-components-shared-DropSection-uploadIcon",
	"dropzone": "src-components-shared-DropSection-dropzone",
	"dropzone_drag": "src-components-shared-DropSection-dropzone_drag",
	"uploadLink": "src-components-shared-DropSection-uploadLink"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/DropSection/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/DropSection/styles.scss
// module chunks = 1